export const defaultData = {
  business: {
    businessName: '',
    businessAddress: '',
    businessTel: ''
  },
  jobAddress: {
    jobName: '',
    jobAddress: '',
    jobTel: ''
  },
  landlordAgent: {
    landlordName: '',
    landlordAddress: '',
    landlordTel: ''
  },
  heatPump: {
    make: '',
    model: '',
    serialNumber: '',
    location: 'Plant Room',
    compressorCurrentAmps: 12.5,
    sightGlassClear: 'Clear / Dry (Green)'
  },
  groundLoop: {
    collectorType: 'Borehole (Vertical)',
    brinePressureBar: 1.8,
    glycolFreezePoint: '-15°C (30% Propylene Glycol)',
    brineDeltaTC: 3.2,
    strainerCleaned: 'Yes'
  },
  vesselDetails: {
    make: '',
    model: '',
    location: 'Plant Room',
    capacity: 250,
    makersWarningLabel: 'Yes',
    scaleReducerFitted: 'Yes',
    immersionTested: 'Yes'
  },
  operatingDetails: {
    systemOperatingPressure: 1.5,
    operatingPressureExpansionVessel: 1.5,
    prvLiftTest: 'Pass / Operating Correctly',
    dischargeCompliant: 'Compliant (Continuous fall)'
  },
  defects: {
    defectsIdentified: ''
  },
  workCarriedOut: {
    workCarriedOut: 'Annual ground source heat pump maintenance completed: brine loop filter cleaned, glycol refractometer test verified, heating system safety valves tested.'
  },
  receivedBy: {
    receivedByName: '',
    receivedByDate: new Date().toISOString().split('T')[0]
  },
  issuedBy: {
    issuedByName: '',
    engineerSignature: '',
    issuedByDate: new Date().toISOString().split('T')[0]
  }
};

export default defaultData;
